import { render } from "./FieldRectangle.vue?vue&type=template&id=89d8bae8"
import script from "./FieldRectangle.vue?vue&type=script&lang=js"
export * from "./FieldRectangle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__